// export default DataTableComponent;
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { debounce } from 'lodash';
import DataTable from 'react-data-table-component';
import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import $ from 'jquery';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'select2/dist/css/select2.min.css';
import 'select2/dist/js/select2.min.js';

const InvoiceIcons = ({ uniqueCode, receiptFlag, feedbackFlag }) => {
  const receiptLink = `/${uniqueCode}`;
  const feedbackLink = `${process.env.REACT_APP_FEEDBACK_URL}/${uniqueCode}`;
  console.log('Shahzad' , receiptFlag);

  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      {receiptFlag === '1' && (
        <a href={receiptLink} target="_blank" rel="noopener noreferrer" title="Digital Receipt">
        <img
            id='modal-setup-img'
            src="assets/images/invoice_listing_icons/receipt.svg"
            alt=""
            style={{height: '40px',
                    padding: '6px',
                    border: '2px solid #81a683',
                    borderRadius: '8px',
            }}
        />
        </a>
      )}
      {feedbackFlag === '1' && (
        <a href={feedbackLink} target="_blank" rel="noopener noreferrer" title="Feedback">
         <img
            id='modal-setup-img'
            src="assets/images/invoice_listing_icons/feedback-icon.svg"
            alt=""
            style={{height: '40px',
                    padding: '6px',
                    border: '2px solid #81a683',
                    borderRadius: '8px',
            }}
        />
        </a>
      )}
    </div>
  );
};


const InvoiceDropdown = ({ invoiceNumber }) => {
  return <span>{invoiceNumber}</span>;
};


const DataTableComponent = ({ businessId, token, userbranchData, selectedBranchProp,receipt_flag,feedback_flag }) => {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedBranch, setSelectedBranch] = useState('0');
    const [sortField, setSortField] = useState('invoice_date');
    const [sortOrder, setSortOrder] = useState('desc');
    const All = 'All';
    const isFirstSort = useRef(true);
    const isFirstPage = useRef(true);
    const isFirstRowsPerPage = useRef(true);
    const initialLoad = useRef(true);

    const handleSort = (column, sortDirection) => {
         if (isFirstSort.current) {
            isFirstSort.current = false;
            return;
        }
        const fieldMap = {
            "S.No": "s_no",
            "Invoice No": "invoice_number",
            "Customer Name": "customer_name",
            "Branch Name": "branch_name",
            "Date": "invoice_date",
            "Cell": "customer_cell",
            "Discount": "discount",
            "Paid Amount": "paid_amount",
            "Rating": "rating",
            "Review": "review",
        };

        const mappedField = fieldMap[column.name] || 'invoice_date';
        setSortField(mappedField);
        setSortOrder(sortDirection);
        fetchInvoices(currentPage, searchTerm, rowsPerPage, mappedField, sortDirection);
    };

    const fetchInvoices = async (page = 1, search = '', rowsPerPage = 10, sortField, sortOrder) => {
        setLoading(true);

        try {
            const queryParams = new URLSearchParams({
                page,
                search,
                limit: rowsPerPage,
                fromDate: fromDate || '',
                toDate: toDate || '',
                branchId: selectedBranch || '0',
                sortField,
                sortOrder,
            }).toString();

            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/fetch-invoices/${businessId}?${queryParams}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            setInvoices(data.invoices);
            setTotalPages(data.totalPages);
            setCurrentPage(data.page);
        } catch (error) {
            console.error('Error fetching invoices:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        fetchInvoices(1, searchTerm, rowsPerPage, sortField, sortOrder);
    };

    const handleClearDates = () => {
        setFromDate('');
        setToDate('');
        setSelectedBranch('0');
        $('#fromDate').val('');
        $('#toDate').val('');
        $('#branchSelect').val('0').trigger('change');
        // $('#runButton').trigger("click");
        setTimeout(() => {
            $('#runButton').trigger("click");
        }, 500);
    };

    const handlePageChange = (page) => {
        if (isFirstPage.current) {
            isFirstPage.current = false;
            return;
        }
        setCurrentPage(page);
        fetchInvoices(page, searchTerm, rowsPerPage, sortField, sortOrder);
    };
    

    const debouncedFetchInvoices = debounce((search) => {
            fetchInvoices(1, search, rowsPerPage, sortField, sortOrder);
        }, 1000);

   

    const handleSearchChange = (e) => {
        console.log('search call');
        const value = e.target.value;
        setSearchTerm(value);
        debouncedFetchInvoices(value);
    };

    const handleRowsPerPageChange = (newRowsPerPage, page) => {
    if (isFirstRowsPerPage.current) {
        isFirstRowsPerPage.current = false;
        return;
    }
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(page);
        fetchInvoices(page, searchTerm, newRowsPerPage, sortField, sortOrder);
    };

    const wrapText = (text, maxWordsPerLine) => {
        const words = text.split(' ');
        let lines = [];
        for (let i = 0; i < words.length; i += maxWordsPerLine) {
            lines.push(words.slice(i, i + maxWordsPerLine).join(' '));
        }
        return lines.join('<br/>');
    };

    const handleBranchChange = (e) => {
        setSelectedBranch(e.target.value);
    };

  useEffect(() => {
    if (selectedBranchProp && selectedBranchProp !== selectedBranch) {
        sessionStorage.setItem('activeSection', 'reviews');
        setSelectedBranch(selectedBranchProp);
    }

    const $branchSelect = $('#branchSelect');
    if ($branchSelect.length && !$branchSelect.data('select2')) {
        $branchSelect.select2();
    }
    const handleBranchChange = (e) => {
        setSelectedBranch(e.target.value);
    };
    $branchSelect.on('change', handleBranchChange);
    if (selectedBranch !== '0') {
        console.log('call with prop id');
        $('#runButton').trigger("click");
    }
   if (initialLoad.current) {
        if (!selectedBranchProp || selectedBranchProp === '0') {
            console.log('Initial load with branch 0');
            fetchInvoices(currentPage, searchTerm, rowsPerPage, sortField, sortOrder);
        }
        initialLoad.current = false;
    } else if (businessId) {
        fetchInvoices(1, searchTerm, rowsPerPage, sortField, sortOrder);
    }
    return () => {
        $branchSelect.select2('destroy');
        $branchSelect.off('change', handleBranchChange);
    };

}, [selectedBranch, selectedBranchProp, businessId]);

    useEffect(() => {
        $('#fromDate').datepicker({
            format: 'yyyy-mm-dd',
            autoclose: true,
        }).on('changeDate', (e) => {
            setFromDate(e.target.value);
        });

        $('#toDate').datepicker({
            format: 'yyyy-mm-dd',
            autoclose: true,
        }).on('changeDate', (e) => {
            setToDate(e.target.value);
        });
    }, []);

    
    const columns = [
        {
            name: 'S.No',
            selector: (row) => row.id,
            sortable: true,
        },
        {
            name: 'Branch name',
            selector: (row) => row.branch_name,
            sortable: true,
        },
            {
            name: 'Invoice No',
            selector: (row) => (
                  <InvoiceDropdown invoiceNumber={row.invoice_number} />
            ),
            sortable: true,
        },
       
        {
            name: 'Customer Name',
            selector: (row) => row.customer_name,
            sortable: true,
        },
        {
            name: 'Date',
            selector: (row) => row.invoice_date,
            sortable: true,
        },
        {
            name: 'Cell',
            selector: (row) => row.customer_cell,
            sortable: true,
        },
        {
            name: 'Discount',
            selector: (row) => row.discount,
            sortable: true,
        },
        {
            name: 'Paid Amount',
            selector: (row) => `${row.paid_amount} (${row.payment_mode})`,
            sortable: true,
        },
        {
            name: 'Rating',
            selector: (row) => {
                const stars = Array.from({ length: 5 }, (_, index) => index < row.rating);
                const wrappedReview = row.review ? wrapText(row.review, 20) : '';
                return (
                    <span className="styled-tooltip">
                        {row.rating !== null &&
                            stars.map((filled, index) => (
                                <span key={index} className={`star ${filled ? 'filled' : ''}`} >
                                    ★
                                </span>
                            ))}
                        {row.rating !== null && row.review && (
                            <span className="tooltiptext" dangerouslySetInnerHTML={{ __html: wrappedReview }}></span>
                        )}
                    </span>
                );
            },
            sortable: true,
        },
         {
            name: 'View',
            selector: (row) => (
            <InvoiceIcons
                uniqueCode={row.unique_code}
                receiptFlag={receipt_flag}
                feedbackFlag={feedback_flag}
            />
            ),
            sortable: false,
        },
    ];
    return (
          <div className="content">
            <div className="col-sm-12 print-hidden">
                <div className="card-box">
                    <h4 className="header-title m-t-0 m-b-30">Filters:</h4>
                    <form id='filter-form' onSubmit={handleFilterSubmit}>
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <label className="control-label">From:</label>
                                 <input
                                    type="text"
                                    className="form-control"
                                    id="fromDate"
                                    placeholder="YYYY-MM-DD"
                                />
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <label className="control-label">To:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="toDate"
                                    placeholder="YYYY-MM-DD"
                                />
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <label className="control-label">Branch:</label>
                                <select
                                    id="branchSelect"
                                    className="form-control"
                                    value={selectedBranch}
                                    onChange={handleBranchChange}
                                >
                                    <option value="0" >All</option>
                                    {Array.isArray(userbranchData) ? (
                                        userbranchData.map((branch) => (
                                            <option key={branch.id_branch} value={branch.id_branch}>
                                                {branch.branch_name}
                                            </option>
                                        ))
                                    ) : (
                                        <option disabled>No branches available</option>
                                    )}
                                </select>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <label className="control-label" style={{ visibility: 'hidden' }}>Not Visible</label>
                                <button type="submit" className="btn btn-primary" id="runButton">Run</button>
                                <div className="filters-buttons-div" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                    <a href="#" id="clear-btn" onClick={(e) => { e.preventDefault(); handleClearDates(); }}>
                                        Clear
                                    </a>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div >
            <div className='col-12' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', marginTop: '30px' }}>
                <div>
                    <CSVLink
                        data={invoices.map(invoice => ({
                            'S.No': invoices.indexOf(invoice) + 1,
                            'Invoice No': invoice.invoice_number,
                            'Customer Name': invoice.customer_name,
                            'Date': invoice.invoice_date,
                            'Cell': invoice.customer_cell,
                            'Discount': invoice.discount,
                            'Paid Amount': `${invoice.paid_amount} (${invoice.payment_mode})`,
                            'Rating': invoice.rating,
                        }))}
                        filename={"invoices.csv"}
                        className="btn btn-primary print-hidden"
                        style={{ margin: '2px' }}
                    >
                        CSV
                    </CSVLink>
                    <button className="btn btn-primary print-hidden" onClick={() => window.print()} style={{ margin: '2px' }}>
                        Print
                    </button>
                </div>
                <input
                    type="text"
                    className='form-control print-hidden'
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    style={{ width: '200px' }}
                />
            </div>
            <div className='col-12'>
                <DataTable
                    columns={columns}
                    data={invoices}
                    striped
                    responsive
                    noDataComponent="No invoices found."
                    pagination
                    paginationServer
                    paginationTotalRows={totalPages * rowsPerPage}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    page={currentPage}
                    onSort={handleSort}
                    sortServer
                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50, 100]}
                />
            </div>

        </div >
    );
};

export default DataTableComponent;
